import React, { Suspense, lazy } from 'react';
import { FacebookPixel } from './components/FacebookPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
// Lazy load below-the-fold sections
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const MethodSection = lazy(() => import('./components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const OfferStack = lazy(() => import('./components/OfferStack').then(m => ({
  default: m.OfferStack
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ComparisonSection = lazy(() => import('./components/ComparisonSection').then(m => ({
  default: m.ComparisonSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
const FloatingCTA = lazy(() => import('./components/FloatingCTA').then(m => ({
  default: m.FloatingCTA
})));
export function App() {
  return <div className="min-h-screen bg-night-900 text-gray-100 font-sans selection:bg-accent-blue/30 selection:text-white" data-id="element-0">
      <FacebookPixel data-id="element-1" />
      <UrgencyBar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <Suspense fallback={null} data-id="element-4">
        <PainSection data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <MethodSection data-id="element-7" />
        <OfferStack data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <ComparisonSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <SocialProofPopup data-id="element-13" />
        <FloatingCTA data-id="element-14" />
      </Suspense>
    </div>;
}